import React, { useContext, useEffect } from 'react';

import { PagesQuery } from '../../generated/graphql';
import { TrackingContext } from '../../TrackingContext';
import { PageCardUIContext } from '../../PageCardUIContext';
import CardContainer from '../CardContainer';
import AddToPageButton from './AddToPageButton';
import PageCardItems from './PageCardItems';
import PageHeader from './PageHeader';
import Card from '../Card';
import PageGuidance from '../PageGuidance';
import TransientRoomRailCard from '../TansientRoomRailCard';

export type Page = PagesQuery['pages'][0];

export interface Props {
  page: Page;
  liteSite: boolean;
  scrollIntoView?: boolean;
}

const PageCard: React.FC<Props> = ({ page, liteSite, scrollIntoView }) => {
  const { setPagesLoaded } = useContext(TrackingContext);
  const { isPageOpenObj, togglePageOpen } = useContext(PageCardUIContext);
  const open = isPageOpenObj[page.id];
  const guidance = !!(liteSite && page.show && !page.items.length);

  // To get here the PagesQuery is finished and is a good time to start loading TrackingContext
  useEffect(() => {
    setPagesLoaded(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CardContainer id={page.routeName || ''} page={page} scrollIntoView={scrollIntoView}>
      <Card dashedBorder={guidance}>
        <PageHeader page={page} open={open} toggleOpen={(): void => togglePageOpen(page.id)} guidance={guidance} />
        {open &&
          (guidance ? (
            <PageGuidance page={page} />
          ) : (
            <>
              <PageCardItems page={page} />
              <AddToPageButton page={page} />
              {page.type === 'TravelPage' && <TransientRoomRailCard page={page} isRailCard={false} />}
            </>
          ))}
      </Card>
    </CardContainer>
  );
};

export default PageCard;
